import React, { useEffect, useState } from 'react';
import { supabaseClient } from '../../../config/supabase';
import Modal3D from '../../ui/Modal3D';
import StartEventFlow from './StartEventFlow';
import { loadClients, newRequestId, staffContext, staffStartEvent } from './foundationApi';

// Staff start an event on a CRM client's behalf with the same flow the client uses. It still begins as a request.
export default function StaffStartEvent({ client = supabaseClient, onClose, onCreated, readWorkbook = null }) {
    const [search, setSearch] = useState('');
    const [clients, setClients] = useState([]);
    const [accountId, setAccountId] = useState('');
    const [context, setContext] = useState(null);
    const [error, setError] = useState('');
    const [requestId] = useState(newRequestId);

    useEffect(() => {
        let alive = true;
        const timer = setTimeout(() => { loadClients(client, search).then((rows) => { if (alive) setClients(rows || []); }).catch((e) => { if (alive) setError(e.message); }); }, 200);
        return () => { alive = false; clearTimeout(timer); };
    }, [client, search]);
    useEffect(() => {
        let alive = true;
        setContext(null);
        if (accountId) staffContext(client, accountId).then((c) => { if (alive) setContext(c); }).catch((e) => { if (alive) setError(e.message); });
        return () => { alive = false; };
    }, [client, accountId]);

    const picker = (
        <div className="ef-grid" data-testid="client-picker">
            <label className="ef-field"><span className="ef-field__label">Find the client</span><input type="search" value={search} onChange={(e) => setSearch(e.target.value)} placeholder="Client name" /></label>
            <label className="ef-field"><span className="ef-field__label">Client (CRM account)</span>
                <select value={accountId} onChange={(e) => setAccountId(e.target.value)} data-testid="client-select">
                    <option value="">Choose a client</option>
                    {clients.map((c) => <option key={c.id} value={c.id}>{c.name}</option>)}
                </select></label>
        </div>
    );
    return (
        <Modal3D portal size="wide" title="Start an event for a client" subtitle="Every event belongs to a client and begins as a request." onClose={() => onClose?.()}>
            <div className="ef-panel">
                {error && <p role="alert" className="ef-problems">{error}</p>}
                {!accountId || !context ? <>{picker}{accountId && <p className="ef-muted">Loading…</p>}</> : (
                    <StartEventFlow key={accountId} addressClient={client} vendorAccountId={accountId} context={context} forClient={false} before={picker} readWorkbook={readWorkbook}
                        onSubmit={(payload) => staffStartEvent(client, accountId, requestId, payload)}
                        onCancel={(result) => { if (result) onCreated?.(result); onClose?.(); }} />
                )}
            </div>
        </Modal3D>
    );
}
